<template>
  <div class="pay-page">
    <myHeader :title="title"></myHeader>
    <div class="pay-info">
      <p>订单号：{{order_number}}</p>
      <p>
        应付金额：
        <icon-price :priceType="this.type == 12 ? 2 : 1"></icon-price>
        {{order_price | toFixPrice}}
      </p>
    </div>
    <van-radio-group v-model="radio">
      <van-cell-group>
        <van-cell title="微信支付" clickable @click="radio = '1'">
          <i class="pay-wx" slot="icon" />
          <van-radio slot="right-icon" name="1" :checked-color="$theme_color" />
        </van-cell>
        <van-cell title="支付宝支付" clickable @click="radio = '2'" v-if="!$pub.isWeiXin()">
          <i class="pay-img" slot="icon" />
          <van-radio slot="right-icon" name="2" :checked-color="$theme_color" />
        </van-cell>
      </van-cell-group>
    </van-radio-group>
    <div class="price-btn">
      <van-button @click="onPay">提交订单</van-button>
      <p class="price">{{order_price | toFixPrice}}</p>
      <icon-price size="mini" :priceType="this.type == 12 ? 2 : 1"></icon-price>
      <p class="default">实付价格：</p>
    </div>
  </div>
</template>

<script>
import myHeader from "@/components/Header";
import wx from "weixin-js-sdk";
export default {
  name: "Pay",
  components: {
    myHeader
  },
  data() {
    return {
      title: {
        name: "订单支付"
      },
      order_price: this.$route.query.order_price / 1,
      order_number: this.$route.query.order_number,
      type: this.$route.query.type,
      radio: "1"
    };
  },
  computed: {
    app() {
      return this.$store.state.app;
    }
  },
  methods: {
    /**
     * 支付
     *  */
    onPay() {
      //选择支付方式  如果是ios内购 请到=>AppPay
      let params = {
        orderNumber: this.order_number,
        shop_id: this.$route.query.shop_id
      };
      if (this.radio == "1") {
        params.payType = "wx";
      } else {
        params.payType = "ali";
      }
      // 安卓支付
      if (this.app) {
        this.$pub.appAction("pay", params);
      } else {
        if (this.radio == "2") {
          this.Alipay();
        } else {
          if (this.$pub.isWeiXin()) {
            this.getCode();
          } else {
            this.wxPay();
          }
        }
      }
    },
    /**
     * 获取code用来在微信内置浏览器支付使用
     *  */
    getCode() {
      // 获取code
      this.$http
        .get(`/api/app/pay/wxUrl`, { order_number: this.order_number })
        .then(data => {
          window.location.href = data.url;
        });
    },
    /**
     * 浏览器打开微信app进行支付
     * */
    wxPay() {
      this.$http
        .post(`/api/app/pay`, {
          type: "wx",
          order_number: this.order_number
        })
        .then(res => {
          window.location.href = res.response.mweb_url;
        });
    },
    /**
     * 浏览器打开支付宝app支付
     * */
    Alipay() {
      this.$http
        .post(`/api/app/pay`, {
          type: "ali",
          order_number: this.order_number
        })
        .then(res => {
          const div = document.createElement("div");
          div.innerHTML = res.response;
          document.body.appendChild(div);
          document.forms.alipay_submit.submit();
        });
    }
  },
  /**
   *  微信内支付检测
   */
  created() {
    if (this.$pub.isWeiXin()) {
      this.is_weixin = true;
      if (window.location.href.search("code") < 0) {
        return;
      }
      // 检测当前地址是否为微信授权回调地址
      let code = window.location.href.split("code=")[1].split("&")[0];
      if (code) {
        this.$http
          .post(
            `/api/app/pay`,
            {
              type: "wx",
              order_number: this.order_number,
              code
            },
            "WXH5"
          )
          .then(res => {
            const data = res.response;
            // 微信sdk授权签名
            wx.config({
              appId: data.appId,
              timestamp: data.timeStamp, // 必填，生成签名的时间戳
              nonceStr: data.nonceStr, // 必填，生成签名的随机串
              signature: data.paySign, // 必填，签名
              jsApiList: ["chooseWXPay"] // 必填，需要使用的JS接口列表
            });
            wx.ready(() => {
              // 唤起微信内sdk支付
              wx.chooseWXPay({
                timestamp: data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
                package: data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                paySign: data.paySign, // 支付签名
                success: () => {
                  // 支付成功回调
                  this.$pub.ToOrder(this.type);
                }
              });
            });
            wx.error(res => {
              this.$toast(res);
            });
          });
      }
    }
    // app回调监听
    if (this.app) {
      this.$pub.registerWebViewJavascriptBridge(() => {
        this.$pub.ToOrder(this.type);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.pay-page {
  @extend %default-bg;
  .pay-info {
    width: 710px;
    height: 200px;
    background: rgba(255, 255, 255, 1);
    border-radius: 8px;
    text-align: center;
    margin: 30px auto;
    padding: 40px;
    box-sizing: border-box;
    line-height: 60px;
    p {
      &:nth-child(1) {
        font-size: 28px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(89, 89, 89, 1);
      }
      &:nth-child(2) {
        font-size: 34px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(89, 89, 89, 1);
      }
    }
  }
  .pay-wx {
    width: 60px;
    height: 100%;
    background: url("../../assets/images/pay-wx.png") no-repeat left center;
    background-size: 48px 38px;
  }
  .pay-other {
    width: 60px;
    height: 100%;
    background: url("../../assets/images/pay-other.png") no-repeat left center;
    background-size: 34px 44px;
  }
  .pay-img {
    width: 60px;
    height: 100%;
    background: url("../../assets/images/pay-zhifubao.png") no-repeat left
      center;
    background-size: 38px 38px;
  }
  /deep/ .van-radio__icon .van-icon {
    font-size: 24px;
  }
}
.price-btn {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 108px;
  background: #fff;
  /deep/ .price-ico {
    margin-bottom: 4px;
  }
  p.default {
    font-family: PingFangSC-Medium;
    color: #595959;
    font-size: 28px;
    padding: 10px 4px 0 48px;
  }
  p.price {
    color: #e02020;
    font-size: 28px;
    margin-left: 2px;
    margin-right: 24px;
    padding-top: 4px;
  }
  img {
    width: 20px;
    margin-top: 10px;
  }
  button {
    width: 226px;
    height: 74px;
    background: rgba(65, 105, 255, 1);
    border-radius: 37px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    font-size: 26px;
    text-align: center;
    line-height: 74px;
    background: $theme_color;
    border: 0;
    margin-right: 20px;
  }
}
</style>
